import axios from "axios";

export class ProductSelector extends ProgressIndicator {
	private readonly productSelector: JQuery;

	constructor(containerId: DOMElementIdentifier, _constructionParameters: ConstructionParameters) {
		super(jQuery("#" + containerId)[0]);

		this.productSelector = jQuery("#" + containerId);
		this.productSelector.on("updateProductSelector", (event) => void this.onUpdate(event));
	}

	private async onUpdate(_event: JQuery.Event): Promise<void> {
		this.showProgressIndicator(true, "", false);
		const url = this.productSelector.data("update-url");

		try {
			const { data } = await axios.get(url);
			this.onUpdateSucceeded(data);
		}
		finally {
			this.hideProgressIndicator();
		}
	}

	private onUpdateSucceeded(data: any) {
		if (data.success) {
			this.productSelector.replaceWith(data.newProductSelector);
		}
	}
}
